import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { Modal } from "../../molecules";
import { Button } from "../../atoms";
import { ConfirmModalType } from "./ConfirmModal.type";

export const ConfirmModal: FC<ConfirmModalType> = ({
  headerTitle,
  mainContent,
  handleModalClose,
  handleModalConfirm,
}) => (
  <Modal
    open
    header={{ children: <Typography>{headerTitle}</Typography> }}
    main={{
      children: (
        <Box>
          {mainContent.map((content) => (
            <Typography key={content}>{content}</Typography>
          ))}
        </Box>
      ),
    }}
    footer={{
      children: (
        <Box>
          <Button
            variant="outlined"
            sx={{
              color: "black",
              border: "0.5px solid grey",
              mr: "10px",
            }}
            btnsize={40}
            onClick={handleModalClose}
          >
            취소
          </Button>
          <Button
            variant="contained"
            color="primaryPink"
            btnsize={40}
            onClick={handleModalConfirm}
          >
            확인
          </Button>
        </Box>
      ),
    }}
  />
);
